import { nonUi } from "./non"
import { sjnUi } from "./sjn"
import { naviUi } from "./art-x-navi"
import { hutteseUi } from "./art-x-huttese"
import { highValyrianUi } from "./art-x-hv"
import type { SpecialLocale, SpecialLocaleUi } from "./specialLocaleTypes"

export const SPECIAL_UI: Record<SpecialLocale, SpecialLocaleUi> = {
  non: nonUi, sjn: sjnUi, "art-x-navi": naviUi,
  "art-x-huttese": hutteseUi, "art-x-hv": highValyrianUi,
}

export function isSpecialLocale(locale: string): locale is SpecialLocale {
  return Object.prototype.hasOwnProperty.call(SPECIAL_UI, locale)
}

export function specialLocaleField<K extends keyof SpecialLocaleUi>(key: K): Record<SpecialLocale, SpecialLocaleUi[K]> {
  return Object.fromEntries(Object.entries(SPECIAL_UI).map(([locale, ui]) => [locale, ui[key]])) as Record<SpecialLocale, SpecialLocaleUi[K]>
}
